import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { NgxPermissionsModule } from "ngx-permissions";
import {
    ReactiveFormsModule,
    FormsModule
} from "@angular/forms";
import { DetalleNoticiaPaginaRoutingModule } from "./detalle-noticia-pagina-routing.module";
import { BotonToggleModule } from "../../../../../components/boton/boton-toggle.module";
import { PipesModule } from "../../../../../pipes/pipes.module";
import { MaterialModule } from "../../../../../components/material/material.module";
import { VolverModule } from "../../../../../components/volver/volver.module";
import { NoticiaModule } from "../../../../../forms/noticias/noticia.module";
import { DetalleNoticiaPaginaComponent } from "./detalle-noticia-pagina.component";
import { ArchivoNoticiaModule } from "../../../../../forms/noticias/archivos-noticia/archivo-noticia.module";

@NgModule({
    imports: [
        CommonModule,
        NgxPermissionsModule.forChild(),
        ReactiveFormsModule,
        FormsModule,
        DetalleNoticiaPaginaRoutingModule,
        BotonToggleModule,
        PipesModule,
        MaterialModule,
        VolverModule,
        NoticiaModule,
        ArchivoNoticiaModule,
    ],
    declarations: [
        DetalleNoticiaPaginaComponent
    ],
    providers: [

    ],
    entryComponents: [

    ]
})
export class DetalleNoticiaPaginaModule { }